module.exports = __webpack_public_path__ + "static/media/galerie.938cc162.jpg";